import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './helpers/authentication.guard';
import { RoleGuard } from './helpers/role.guard';
import { FullComponent } from './components/layout/full/full.component';
import { HomeComponent } from './components/pages/home/home.component';
import { GoogleLoginComponent } from './authentication/googlelogin/googlelogin.component';
import { ImmaginiComponent } from './components/pages/dam/immagini/immagini.component';
import { GallerieComponent } from './components/pages/dam/gallerie/gallerie.component';
import { DocumentiComponent } from './components/pages/dam/documenti/documenti.component';
import { UserComponent } from './components/pages/admin/user/user.component';
import { SupervisoriComponent } from './components/pages/admin/supervisori/supervisori.component';
import { SubfooterComponent } from './components/pages/subfooter/subfooter.component';
import { HeaderEntityComponent } from './components/pages/header-entity/header-entity/header-entity.component';
import { FooterEntityComponent } from './components/pages/footer-entity/footer-entity/footer-entity.component';
import { StoreComponent } from './components/pages/store/store/store.component';
import { PromoComponent } from './components/pages/store/promo/promo.component';
import { ProdottiComponent } from './components/pages/store/prodotti/prodotti.component';
import { GestioneorariComponent } from './components/pages/store/gestioneorari/gestioneorari.component';
import { AccessoristoreComponent } from './components/pages/store/accessoristore/accessoristore.component';
import { ContattistoremanagerComponent } from './components/pages/store/contattistoremanager/contattistoremanager.component';
import { AppointmentComponent } from './components/pages/appointment/appointment/appointment.component';
import { TopicManagementComponent } from './components/pages/appointment/topic-management/topic-management.component';
import { AppointmentTimesComponent } from './components/pages/appointment/appointment-times/appointment-times.component';
import { ExportCsvEmailListsComponent } from './components/pages/appointment/export-csv-email-lists/export-csv-email-lists.component';
import { SimComponent } from './components/pages/clickandcollect/sim/sim.component';
import { SmartphoneComponent } from './components/pages/clickandcollect/smartphone/smartphone.component';
import { CustompageComponent } from './components/pages/custompage/custompage/custompage.component';
import { NewsFiltersComponent } from './components/pages/custompage/news-filters/news-filters.component';
import { ShoppingCentersComponent } from './components/pages/custompage/shopping-centers/shopping-centers.component';
import { StoreprenotaeritiraComponent } from './components/pages/store/storeprenotaeritira/storeprenotaeritira.component';
import { PromoCreateComponent } from './components/pages/store/promo/promo-create/promo-create.component';
import { PromoEditComponent } from './components/pages/store/promo/promo-edit/promo-edit.component';
import { ProdottiCreateComponent } from './components/pages/store/prodotti/prodotti-create/prodotti-create.component';
import { ProdottiEditComponent } from './components/pages/store/prodotti/prodotti-edit/prodotti-edit.component';
import { HeaderEntityCreateComponent } from './components/pages/header-entity/header-entity-create/header-entity-create.component';
import { HeaderEntityEditComponent } from './components/pages/header-entity/header-entity-edit/header-entity-edit.component';
import { FooterEntityCreateComponent } from './components/pages/footer-entity/footer-entity-create/footer-entity-create.component';
import { FooterEntityEditComponent } from './components/pages/footer-entity/footer-entity-edit/footer-entity-edit.component';
import { GallerieCreateComponent } from './components/pages/dam/gallerie/gallerie-create/gallerie-create.component';
import { GallerieEditComponent } from './components/pages/dam/gallerie/gallerie-edit/gallerie-edit.component';
import { SimViewComponent } from './components/pages/clickandcollect/sim/sim-view/sim-view.component';
import { SmartphoneViewComponent } from './components/pages/clickandcollect/smartphone/smartphone-view/smartphone-view.component';
import { StoreEditComponent } from './components/pages/store/store/store-edit/store-edit.component';
import { AppointmentViewComponent } from './components/pages/appointment/appointment/appointment-view/appointment-view.component';
import { AppointmentCalendarComponent } from './components/pages/appointment/appointment/appointment-calendar/appointment-calendar.component';
import { CustompageEditComponent } from './components/pages/custompage/custompage/custompage-edit/custompage-edit.component';

import { InfoLoggedUserComponent } from './components/pages/info-logged-user/info-logged-user.component';
import { ResellerComponent } from './components/pages/reseller/reseller.component';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { RolesResourceEnum } from './models/roles.resource';
import { DigitalcouponComponent } from './components/pages/digitalcoupon/digitalcoupon.component';
import { DigitalcouponViewComponent } from './components/pages/digitalcoupon/digitalcoupon-view/digitalcoupon-view.component';
import { ActivityMapComponent } from './components/pages/custompage/activity-map/activity-map.component';
import { LoadXmlComponent } from './components/pages/xml-2/load-xml/load-xml.component';



const roles = RolesResourceEnum;
const routes: Routes = [
    {
        path: '',
        component: FullComponent,
        canActivate: [AuthGuard],
        children: [
            { path: '', redirectTo: '/home', pathMatch: 'full' },
            { path: 'home', component: HomeComponent },

            /*  DAM */
            {
                path: 'dam/immagini',
                component: ImmaginiComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'IMMAGINI',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'D.A.M' },
                        { title: 'Immagini' }
                    ]
                }
            }, {
                path: 'dam/gallerie',
                component: GallerieComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'GALLERIE',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'D.A.M' },
                        { title: 'Gallerie' }
                    ]
                }
            }, {
                path: 'dam/gallerie/create',
                component: GallerieCreateComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'NUOVA GALLERIA',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'D.A.M' },
                        { title: 'Gallerie' },
                        { title: 'Crea nuova' }
                    ]
                }
            }, {
                path: 'dam/gallerie/:id',
                component: GallerieEditComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'MODIFICA GALLERIA',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'D.A.M' },
                        { title: 'Gallerie' },
                        { title: 'Modifica galleria' }
                    ]
                }
            }, {
                path: 'dam/documenti',
                component: DocumentiComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'DOCUMENTI',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'D.A.M' },
                        { title: 'Documenti' }
                    ]
                }
            },

            /* Store */
            {
                path: 'store/store',
                component: StoreComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'STORE',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'STORE' },
                        { title: 'Store' }
                    ]
                }
            }, {
                path: 'store/store/:id',
                component: StoreEditComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'STORE',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'STORE' },
                        { title: 'Store' },
                        { title: 'Modifica' }
                    ]
                }
            }, {
                path: 'store/store-prenotaeritira',
                component: StoreprenotaeritiraComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'STORE C&C',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'STORE' },
                        { title: 'Store C&C' }
                    ]
                }
            }, {
                path: 'store/promo',
                component: PromoComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'PROMOZIONE ED EVENTI',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'STORE' },
                        { title: 'Promozione ed Eventi' }
                    ]
                }
            }, {
                path: 'store/promo/create',
                component: PromoCreateComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'PROMOZIONE ED EVENTI',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'STORE' },
                        { title: 'Promozione ed Eventi' },
                        { title: 'Crea nuova' }
                    ]
                }
            }, {
                path: 'store/promo/:id',
                component: PromoEditComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'PROMOZIONE ED EVENTI',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'STORE' },
                        { title: 'Promozione ed Eventi' },
                        { title: 'Modifica' }
                    ]
                }
            }, {
                path: 'store/prodotti',
                component: ProdottiComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'PRODOTTI E SERVIZI',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'STORE' },
                        { title: 'Prodotti e Servizi' }
                    ]
                }
            }, {
                path: 'store/prodotti/create',
                component: ProdottiCreateComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'PRODOTTI E SERVIZI',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'STORE' },
                        { title: 'Prodotti e Servizi' },
                        { title: 'Crea nuova' }
                    ]
                }
            }, {
                path: 'store/prodotti/:id',
                component: ProdottiEditComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'PRODOTTI E SERVIZI',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'STORE' },
                        { title: 'Prodotti e Servizi' },
                        { title: 'Modifica' }
                    ]
                }
            }, {
                path: 'store/gestioneorari',
                component: GestioneorariComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'GESTIONE ORARI',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'STORE' },
                        { title: 'Gestione orari' }
                    ],
                    expectedRole:[
                        roles.ROLE_STOREMANAGER_FLAGSHIP_MONOBRAND,
                        roles.ROLE_STOREMANAGER_FRANCHISING,
                        roles.ROLE_STOREMANAGER_SUPERVISOR
                    ]
                }
            }, {
                path: 'store/accessoristore',
                component: AccessoristoreComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'ACCESSORI STORE',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'STORE' },
                        { title: 'Accessori store' }
                    ]
                }
            }, {
                path: 'store/contattistoremanager',
                component: ContattistoremanagerComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'CONTATTI STORE MANAGER',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'STORE' },
                        { title: 'Contatti store manager' }
                    ]
                }
            },

            /*  Appuntamenti */
            {
                path: 'appointment/appointment',
                component: AppointmentComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'APPUNTAMENTI',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'Appuntamenti' },
                        { title: 'Appuntamenti' }
                    ],
                    expectedRole:[
                        roles.ROLE_STOREMANAGER_FLAGSHIP_MONOBRAND,
                        roles.ROLE_STOREMANAGER_FRANCHISING,
                        roles.ROLE_STOREMANAGER_SUPERVISOR
                    ]
                }
            }, {
                path: 'appointment/appointment/:id',
                component: AppointmentViewComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'DETTAGLIO APPUNTAMENTI',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'Appuntamenti' },
                        { title: 'Appuntamenti' },
                        { title: 'Dettaglio Appuntamenti' }
                    ],
                    expectedRole:[
                        roles.ROLE_STOREMANAGER_FLAGSHIP_MONOBRAND,
                        roles.ROLE_STOREMANAGER_FRANCHISING,
                        roles.ROLE_STOREMANAGER_SUPERVISOR
                    ]
                }
            }, {
                path: 'appointment/calendar',
                component: AppointmentCalendarComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'APPUNTAMENTI',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'Appuntamenti' },
                        { title: 'Calendario' }
                    ],
                    expectedRole:[
                        roles.ROLE_STOREMANAGER_FLAGSHIP_MONOBRAND,
                        roles.ROLE_STOREMANAGER_FRANCHISING,
                        roles.ROLE_STOREMANAGER_SUPERVISOR
                    ]
                }
            }, {
                path: 'appointment/topic-management',
                component: TopicManagementComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'GESTIONE ARGOMENTI',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'Appuntamenti' },
                        { title: 'Gestione argomenti' }
                    ]
                }
            }, {
                path: 'appointment/appointment-times',
                component: AppointmentTimesComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'ORARI APPUNTAMENTI',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'Appuntamenti' },
                        { title: 'Orari appuntamenti' }
                    ],
                    expectedRole:[
                        roles.ROLE_STOREMANAGER_FLAGSHIP_MONOBRAND,
                        roles.ROLE_STOREMANAGER_FRANCHISING,
                        roles.ROLE_STOREMANAGER_SUPERVISOR
                    ]
                }
            }, {
                path: 'appointment/export-csv-email-lists',
                component: ExportCsvEmailListsComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'LISTE EMAIL EXPORT CSV',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'Appuntamenti' },
                        { title: 'Liste Email Export Csv' }
                    ]
                }
            },

            //Prenota e ritira
            {
                path: 'clickandcollect/sim',
                component: SimComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'SIM',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'PRENOTA E RITIRA' },
                        { title: 'SIM' }
                    ],
                    expectedRole:[
                        roles.ROLE_STOREMANAGER_FLAGSHIP_MONOBRAND,
                        roles.ROLE_STOREMANAGER_FRANCHISING,
                        roles.ROLE_STOREMANAGER_MULTIBRAND,
                        roles.ROLE_STOREMANAGER_GDS
                    ]
                }
            }, {
                path: 'clickandcollect/sim/:id',
                component: SimViewComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'DETTAGLIO SIM',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'PRENOTA E RITIRA' },
                        { title: 'SIM' },
                        { title: 'DETTAGLIO SIM' }
                    ],
                    expectedRole:[
                        roles.ROLE_STOREMANAGER_FLAGSHIP_MONOBRAND,
                        roles.ROLE_STOREMANAGER_FRANCHISING,
                        roles.ROLE_STOREMANAGER_MULTIBRAND,
                        roles.ROLE_STOREMANAGER_GDS
                    ]
                }
            }, {
                path: 'clickandcollect/smartphone',
                component: SmartphoneComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'SMARTPHONE',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'PRENOTA E RITIRA' },
                        { title: 'SMARTPHONE' }
                    ]
                }
            }, {
                path: 'clickandcollect/smartphone/:id',
                component: SmartphoneViewComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'DETTAGLIO SMARTPHONE',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'PRENOTA E RITIRA' },
                        { title: 'SMARTPHONE' },
                        { title: 'DETTAGLIO SMARTPHONE' }
                    ]
                }
            },
            //Digital coupon
            {
                path: 'digitalcoupon',
                component: DigitalcouponComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'DIGITAL COUPON',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'Digital coupon' },
                    ],
                    expectedRole:[
                        roles.ROLE_STOREMANAGER_FLAGSHIP_MONOBRAND,
                        roles.ROLE_STOREMANAGER_FRANCHISING,
                        roles.ROLE_STOREMANAGER_MULTIBRAND,
                        roles.ROLE_STOREMANAGER_GDS
                    ]
                }
            },{
                path: 'digitalcoupon/:id',
                component: DigitalcouponViewComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'DETTAGLIO DIGITAL COUPON',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'Digital coupon' },
                        { title: 'Dettaglio' }
                    ],
                    expectedRole:[
                        roles.ROLE_STOREMANAGER_FLAGSHIP_MONOBRAND,
                        roles.ROLE_STOREMANAGER_FRANCHISING,
                        roles.ROLE_STOREMANAGER_MULTIBRAND,
                        roles.ROLE_STOREMANAGER_GDS
                    ]
                }
            },
            //Pagine Custom
            {
                path: 'custompage/custompage',
                component: CustompageComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'CONTENUTI CUSTOM',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'PAGINE CUSTOM' },
                        { title: 'Contenuti custom' }
                    ]
                }
            }, {
                path: 'custompage/custompage/edit/:id',
                component: CustompageEditComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'DETTAGLIO PAGINA CUSTOM',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'PAGINE CUSTOM' },
                        { title: 'Contenuti custom' },
                        { title: 'Dettaglio pagina custom' }
                    ]
                }
            }, {
                path: 'custompage/shopping-center',
                component: ShoppingCentersComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'CENTRI COMMERCIALI',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'PAGINE CUSTOM' },
                        { title: 'Centri commerciali' }
                    ]
                }
            }, {
                path: 'custompage/news-filters',
                component: NewsFiltersComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'FILTRI NEWS',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'PAGINE CUSTOM' },
                        { title: 'Filtri news' }
                    ]
                }
            }, {
                path: 'custompage/activity-map',
                component: ActivityMapComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'ATTIVITA\'',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'PAGINE CUSTOM' },
                        { title: 'AttivitÃƒÂ ' }
                    ]
                }
            },





            
            //Reseller
            {
                path: 'reseller',
                component: ResellerComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'RESELLER',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'RESELLER' },
                    ]
                }
            },


            //Header
            {
                path: 'header',
                component: HeaderEntityComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'HEADER',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'Header' }
                    ]
                }
            }, {
                path: 'header/create',
                component: HeaderEntityCreateComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'HEADER',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'Header' },
                        { title: 'Crea' }
                    ]
                }
            }, {
                path: 'header/:id',
                component: HeaderEntityEditComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'HEADER',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'Header' },
                        { title: 'Modifica' }
                    ]
                }
            },

            //Footer
            {
                path: 'footer',
                component: FooterEntityComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'FOOTER',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'Footer' }
                    ]
                }
            }, {
                path: 'footer/create',
                component: FooterEntityCreateComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'FOOTER',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'Footer' },
                        { title: 'Crea' }
                    ]
                }
            }, {
                path: 'footer/:id',
                component: FooterEntityEditComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'FOOTER',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'Footer' },
                        { title: 'Modifica' }
                    ]
                }
            }, 
            
            //Subfooter
            {
                path: 'subfooter',
                component: SubfooterComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'SUBFOOTER',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'Subfooter' }
                    ]
                }
            }, 

            //Admin
            {
                path: 'admin/user',
                component: UserComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'USER',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'Admin' },
                        { title: 'User' }
                    ]
                }
            }, {
                path: 'admin/supervisori',
                component: SupervisoriComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'SUPERVISORI',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'Admin' },
                        { title: 'Supervisori' }
                    ]
                }
            }, 
            
            //Info
            {
                path: 'info-logged-user',
                component: InfoLoggedUserComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'INFO UTENTE',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'Informazioni utente loggato' }
                    ]
                }
            },

            //XML - 2
            {
            path: 'xml-2',
            component: LoadXmlComponent,
            canActivate:[RoleGuard],
            data: {
                title: 'Caricamento XML - 2',
                urls: [
                    { title: 'Home', url: '/home' },
                    { title: 'XML - 2' }
                ],
                expectedRole:[
                    roles.ROLE_STORES_UPLOAD_MANAGER
                ]
            }
        },

            //XML - store-rossi
            {
                path: 'xml-red',
                component: LoadXmlComponent,
                canActivate:[RoleGuard],
                data: {
                    title: 'Caricamento XML - Red',
                    urls: [
                        { title: 'Home', url: '/home' },
                        { title: 'XML - Red' }
                    ],
                    expectedRole:[
                        roles.ROLE_STORES_UPLOAD_MANAGER
                    ]
                }
            }
        ]
    },
    { path: 'login', component: GoogleLoginComponent },
    { path: '**', redirectTo: '/home', pathMatch: 'full' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
    providers: [{provide: LocationStrategy, useClass: HashLocationStrategy}],

})
export class AppRoutingModule { }
